import { render, staticRenderFns } from "./wasteExchangeBed.vue?vue&type=template&id=17c6e1a4&scoped=true&"
import script from "./wasteExchangeBed.vue?vue&type=script&lang=js&"
export * from "./wasteExchangeBed.vue?vue&type=script&lang=js&"
import style0 from "./wasteExchangeBed.vue?vue&type=style&index=0&id=17c6e1a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c6e1a4",
  null
  
)

export default component.exports